import { atom } from "recoil";

export const infoMenuListAtom = atom<JSX.Element | undefined>({
	key: "infoMenuList",
	default: undefined,
});
